export default "__VITE_ASSET__Clfxv6F2__"